/**
 * @deprecated Legacy orders-api client. The OpenAPI spec this was generated from is a stale
 * readme snapshot (pre-`orders-api → horizon` migration), so generated types can diverge from
 * actual server responses. Use `@moment/horizon-data-access` instead — it's generated from
 * the live Horizon spec. See FD-175.
 */
import { baseApiSlice as api } from "./base-api-slice";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postOrder: build.mutation<PostOrderApiResponse, PostOrderApiArg>({
      query: (queryArg) => ({
        url: `/trading/order/`,
        method: "POST",
        body: queryArg.order,
      }),
    }),
    getAllOrders: build.query<GetAllOrdersApiResponse, GetAllOrdersApiArg>({
      query: (queryArg) => ({
        url: `/trading/order/`,
        params: {
          state: queryArg.state,
          account_id: queryArg.accountId,
          client_order_id: queryArg.clientOrderId,
          annotation: queryArg.annotation,
          ib_id: queryArg.ibId,
        },
      }),
    }),
    getOrderByOrderId: build.query<
      GetOrderByOrderIdApiResponse,
      GetOrderByOrderIdApiArg
    >({
      query: (queryArg) => ({ url: `/trading/order/${queryArg.id}/` }),
    }),
    deleteOrderByOrderId: build.mutation<
      DeleteOrderByOrderIdApiResponse,
      DeleteOrderByOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/`,
        method: "DELETE",
        params: {
          cancel_group_members: queryArg.cancelGroupMembers,
        },
      }),
    }),
    allocateOrderByOrderId: build.mutation<
      AllocateOrderByOrderIdApiResponse,
      AllocateOrderByOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/allocate/`,
        method: "POST",
        body: queryArg.postOrderAllocationRequest,
      }),
    }),
    getEvents: build.query<GetEventsApiResponse, GetEventsApiArg>({
      query: (queryArg) => ({
        url: `/trading/events/`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          event_type: queryArg.eventType,
          order_id: queryArg.orderId,
        },
      }),
    }),
    bulkOrderSubmission: build.mutation<
      BulkOrderSubmissionApiResponse,
      BulkOrderSubmissionApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/bulk/`,
        method: "POST",
        body: queryArg.bulkOrderSubmissionRequest,
      }),
    }),
    bulkCancelOrders: build.mutation<
      BulkCancelOrdersApiResponse,
      BulkCancelOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/bulk-cancel/`,
        method: "POST",
        body: queryArg.bulkCancelOrdersRequest,
      }),
    }),
    bulkAdvisorOrderSubmission: build.mutation<
      BulkAdvisorOrderSubmissionApiResponse,
      BulkAdvisorOrderSubmissionApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/advisor-bulk/`,
        method: "POST",
        body: queryArg.bulkOrderSubmissionRequest,
      }),
    }),
    approveOrderByOrderId: build.mutation<
      ApproveOrderByOrderIdApiResponse,
      ApproveOrderByOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/approve/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    rejectOrderByOrderId: build.mutation<
      RejectOrderByOrderIdApiResponse,
      RejectOrderByOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/reject/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateParentOrderMetadata: build.mutation<
      UpdateParentOrderMetadataApiResponse,
      UpdateParentOrderMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/metadata/`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    createExecutionOrderLobSor: build.mutation<
      CreateExecutionOrderLobSorApiResponse,
      CreateExecutionOrderLobSorApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/lob/sor/`,
        method: "POST",
        body: queryArg.executionOrderRequestLobsor,
      }),
    }),
    createExecutionOrderLobManual: build.mutation<
      CreateExecutionOrderLobManualApiResponse,
      CreateExecutionOrderLobManualApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/lob/manual/`,
        method: "POST",
        body: queryArg.executionOrderRequestLobManual,
      }),
    }),
    createExecutionOrderCustodianManual: build.mutation<
      CreateExecutionOrderCustodianManualApiResponse,
      CreateExecutionOrderCustodianManualApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/custodian/manual/`,
        method: "POST",
        body: queryArg.executionOrderRequestCustodianManual,
      }),
    }),
    createExecutionOrderManualRfq: build.mutation<
      CreateExecutionOrderManualRfqApiResponse,
      CreateExecutionOrderManualRfqApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/rfq/manual/`,
        method: "POST",
        body: queryArg.executionOrderRequestManualRfq,
      }),
    }),
    createExecutionOrderAutoExRfq: build.mutation<
      CreateExecutionOrderAutoExRfqApiResponse,
      CreateExecutionOrderAutoExRfqApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/rfq/autoex/`,
        method: "POST",
        body: queryArg.executionOrderRequestAutoExRfq,
      }),
    }),
    createExecutionOrderExternalTrade: build.mutation<
      CreateExecutionOrderExternalTradeApiResponse,
      CreateExecutionOrderExternalTradeApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/external/`,
        method: "POST",
        body: queryArg.executionOrderRequestExternal,
      }),
    }),
    cancelExecutionOrder: build.mutation<
      CancelExecutionOrderApiResponse,
      CancelExecutionOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/${queryArg.executionOrderId}/`,
        method: "DELETE",
      }),
    }),
    reportExternalTrade: build.mutation<
      ReportExternalTradeApiResponse,
      ReportExternalTradeApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/order/${queryArg.id}/execution-order/${queryArg.executionOrderId}/external/trade-report/`,
        method: "POST",
        body: queryArg.externalTradeReport,
      }),
    }),
    deleteAllocation: build.mutation<
      DeleteAllocationApiResponse,
      DeleteAllocationApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/allocation/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    listAllVenueConfigurations: build.query<
      ListAllVenueConfigurationsApiResponse,
      ListAllVenueConfigurationsApiArg
    >({
      query: () => ({ url: `/trading/venue-configurations/` }),
    }),
    listBookingConfigurations: build.query<
      ListBookingConfigurationsApiResponse,
      ListBookingConfigurationsApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/booking-configurations/`,
        params: {
          risk_group_id: queryArg.riskGroupId,
        },
      }),
    }),
    createBookingConfiguration: build.mutation<
      CreateBookingConfigurationApiResponse,
      CreateBookingConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/booking-configurations/`,
        method: "POST",
        body: queryArg.createBookingConfigurationRequest,
      }),
    }),
    updateBookingConfiguration: build.mutation<
      UpdateBookingConfigurationApiResponse,
      UpdateBookingConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/booking-configurations/`,
        method: "PUT",
        body: queryArg.updateBookingConfigurationRequest,
      }),
    }),
    deleteBookingConfigurationById: build.mutation<
      DeleteBookingConfigurationByIdApiResponse,
      DeleteBookingConfigurationByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/booking-configurations/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    proposeExecutionInstruction: build.mutation<
      ProposeExecutionInstructionApiResponse,
      ProposeExecutionInstructionApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/execution-instructions/proposals/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    listAllRulesets: build.query<
      ListAllRulesetsApiResponse,
      ListAllRulesetsApiArg
    >({
      query: () => ({ url: `/trading/execution-instructions/rulesets/` }),
    }),
    upsertRuleset: build.mutation<
      UpsertRulesetApiResponse,
      UpsertRulesetApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/execution-instructions/rulesets/`,
        method: "POST",
        body: queryArg.upsertRulesetRequest,
      }),
    }),
    deleteRuleset: build.mutation<
      DeleteRulesetApiResponse,
      DeleteRulesetApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/execution-instructions/rulesets/${queryArg.id}/scope/${queryArg.scope}/`,
        method: "DELETE",
      }),
    }),
    listSupportedExpressions: build.query<
      ListSupportedExpressionsApiResponse,
      ListSupportedExpressionsApiArg
    >({
      query: () => ({
        url: `/trading/execution-instructions/rulesets/supported-expressions/`,
      }),
    }),
    listAllFeeScheduleRules: build.query<
      ListAllFeeScheduleRulesApiResponse,
      ListAllFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/`,
        params: {
          risk_group_id: queryArg.riskGroupId,
        },
      }),
    }),
    upsertFeeScheduleRules: build.mutation<
      UpsertFeeScheduleRulesApiResponse,
      UpsertFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/`,
        method: "POST",
        body: queryArg.upsertFeeScheduleRulesRequest,
      }),
    }),
    deleteFeeScheduleRules: build.mutation<
      DeleteFeeScheduleRulesApiResponse,
      DeleteFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/${queryArg.id}/`,
        method: "DELETE",
        body: queryArg.deleteFeeScheduleRulesRequest,
      }),
    }),
    listAllRepFeeScheduleRules: build.query<
      ListAllRepFeeScheduleRulesApiResponse,
      ListAllRepFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/rep/`,
        params: {
          risk_group_id: queryArg.riskGroupId,
        },
      }),
    }),
    upsertRepFeeScheduleRules: build.mutation<
      UpsertRepFeeScheduleRulesApiResponse,
      UpsertRepFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/rep/`,
        method: "POST",
        body: queryArg.upsertRepFeeScheduleRulesRequest,
      }),
    }),
    deleteRepFeeScheduleRules: build.mutation<
      DeleteRepFeeScheduleRulesApiResponse,
      DeleteRepFeeScheduleRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/fees/rules/rep/${queryArg.id}/`,
        method: "DELETE",
        body: queryArg.deleteRepFeeScheduleRulesRequest,
      }),
    }),
    getFeesForInstrument: build.query<
      GetFeesForInstrumentApiResponse,
      GetFeesForInstrumentApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/risk_group/${queryArg.id}/fees/${queryArg.instrumentId}/`,
      }),
    }),
    postDefaultTraderForOrg: build.mutation<
      PostDefaultTraderForOrgApiResponse,
      PostDefaultTraderForOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/default/`,
        method: "POST",
        body: queryArg.postDefaultTraderProfileForOrgRequest,
      }),
    }),
    getDefaultTraderForOrg: build.query<
      GetDefaultTraderForOrgApiResponse,
      GetDefaultTraderForOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/default/`,
      }),
    }),
    deleteDefaultTraderForOrg: build.mutation<
      DeleteDefaultTraderForOrgApiResponse,
      DeleteDefaultTraderForOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/default/`,
        method: "DELETE",
      }),
    }),
    getTraderProfile: build.query<
      GetTraderProfileApiResponse,
      GetTraderProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/${queryArg.userId}/profile/`,
      }),
    }),
    createTraderProfile: build.mutation<
      CreateTraderProfileApiResponse,
      CreateTraderProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/${queryArg.userId}/profile/`,
        method: "POST",
        body: queryArg.createTraderProfileRequest,
      }),
    }),
    updateTraderProfile: build.mutation<
      UpdateTraderProfileApiResponse,
      UpdateTraderProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/${queryArg.userId}/profile/`,
        method: "PUT",
        body: queryArg.updateTraderProfileRequest,
      }),
    }),
    deleteTraderProfile: build.mutation<
      DeleteTraderProfileApiResponse,
      DeleteTraderProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/organization/${queryArg.orgId}/trader/${queryArg.userId}/profile/`,
        method: "DELETE",
      }),
    }),
    postOrderCosts: build.mutation<
      PostOrderCostsApiResponse,
      PostOrderCostsApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/calculator/order-costs/`,
        method: "POST",
        body: queryArg.orderCostsRequest,
      }),
    }),
    createBatchListRfqWithAutoEx: build.mutation<
      CreateBatchListRfqWithAutoExApiResponse,
      CreateBatchListRfqWithAutoExApiArg
    >({
      query: (queryArg) => ({
        url: `/trading/list-rfq/batch/`,
        method: "POST",
        body: queryArg.createBatchListRfqRequest,
      }),
    }),
    deleteRfq: build.mutation<DeleteRfqApiResponse, DeleteRfqApiArg>({
      query: (queryArg) => ({
        url: `/trading/rfq/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    createRfq: build.mutation<CreateRfqApiResponse, CreateRfqApiArg>({
      query: (queryArg) => ({
        url: `/trading/rfq/`,
        method: "POST",
        body: queryArg.createRfq,
      }),
    }),
  }),
  overrideExisting: false,
});
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export { injectedRtkApi as ordersApi };
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderApiResponse =
  /** status 200 Successful response */ PostOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderApiArg = {
  order: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetAllOrdersApiResponse = /** status 200 Successful response

An array of Order objects */ OrderRequest[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetAllOrdersApiArg = {
  /** Order state to be queried: 'open', 'closed' or 'all'. Defaults to open. An open order has an order status of pending_approval, pending_execution, or partially_filled, while a closed order has an order status of filled, canceled, or rejected. For more information on order statuses, refer to [Order States and Statuses](ref:understand-orders#order-states-and-statuses). */
  state?: "open" | "closed" | "all";
  /** Unique ID of user account to fetch orders for. */
  accountId?: string;
  /** Filter orders by client order ID. */
  clientOrderId?: ClientOrderId;
  /** Filter orders by annotation contents. */
  annotation?: string;
  ibId?: IntroducingBrokerId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetOrderByOrderIdApiResponse =
  /** status 200 Successful response */ OrderRequest;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetOrderByOrderIdApiArg = {
  /** Order ID */
  id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteOrderByOrderIdApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteOrderByOrderIdApiArg = {
  /** Order ID */
  id: string;
  /** When true, cancel the open quantity of every member of the group parent order along with the parent. Only valid for group parent orders; otherwise the cancel is rejected. */
  cancelGroupMembers?: boolean;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocateOrderByOrderIdApiResponse =
  /** status 201 Successful response */ {
    allocation_id: AllocationId;
  };
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocateOrderByOrderIdApiArg = {
  /** Order ID */
  id: string;
  postOrderAllocationRequest: PostOrderAllocationRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetEventsApiResponse = /** status 200 Successful response */ {
  data?: EventData[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetEventsApiArg = {
  /** The starting message number to retrieve events from. If not provided, begins from the first event. */
  start?: string;
  /** The ending message number to retrieve events up to. If not provided, we will retrieve events up to the most recent event. */
  end?: string;
  /** Filter events by type. */
  eventType?: EventType;
  /** Filter events by order ID. */
  orderId?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkOrderSubmissionApiResponse =
  /** status 201 Successful response */ BulkOrderSubmissionResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkOrderSubmissionApiArg = {
  bulkOrderSubmissionRequest: BulkOrderSubmissionRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkCancelOrdersApiResponse =
  /** status 200 All cancel requests were submitted successfully. */
    | BulkCancelOrdersResponse
    | /** status 207 Multi-Status: at least one order could not be cancelled. The response body lists per-order outcomes; entries with status=rejected (client-side refusal, e.g. malformed ID) or status=failed (downstream infrastructure error) identify the affected order IDs and the reason. */ BulkCancelOrdersResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkCancelOrdersApiArg = {
  bulkCancelOrdersRequest: BulkCancelOrdersRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkAdvisorOrderSubmissionApiResponse =
  /** status 201 Successful response */ BulkOrderSubmissionResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkAdvisorOrderSubmissionApiArg = {
  bulkOrderSubmissionRequest: BulkOrderSubmissionRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ApproveOrderByOrderIdApiResponse =
  /** status 201 Created */ ManualApproveResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ApproveOrderByOrderIdApiArg = {
  id: OrderId;
  body: {
    /** The annotation to be added to the order. */
    annotation?: string | null;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RejectOrderByOrderIdApiResponse =
  /** status 201 Successful response */ ManualRejectResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RejectOrderByOrderIdApiArg = {
  id: OrderId;
  body: {
    /** The reason for rejection, if provided. */
    reason?: string | null;
    /** The annotation to be added to the order for the rejection. */
    annotation?: string | null;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateParentOrderMetadataApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateParentOrderMetadataApiArg = {
  id: OrderId;
  body: {
    [key: string]: string;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderLobSorApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderLobSorApiArg = {
  id: OrderId;
  executionOrderRequestLobsor: ExecutionOrderRequestLobsor;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderLobManualApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderLobManualApiArg = {
  id: OrderId;
  executionOrderRequestLobManual: ExecutionOrderRequestLobManual;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderCustodianManualApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderCustodianManualApiArg = {
  id: OrderId;
  executionOrderRequestCustodianManual: ExecutionOrderRequestCustodianManual;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderManualRfqApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderManualRfqApiArg = {
  id: OrderId;
  executionOrderRequestManualRfq: ExecutionOrderRequestManualRfq;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderAutoExRfqApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderAutoExRfqApiArg = {
  id: OrderId;
  executionOrderRequestAutoExRfq: ExecutionOrderRequestAutoExRfq;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderExternalTradeApiResponse =
  /** status 201 Successful response */ ExecutionOrderResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateExecutionOrderExternalTradeApiArg = {
  id: OrderId;
  executionOrderRequestExternal: ExecutionOrderRequestExternal;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelExecutionOrderApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelExecutionOrderApiArg = {
  id: OrderId;
  executionOrderId: ExecutionOrderId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ReportExternalTradeApiResponse =
  /** status 201 Successful response */ ExternalTradeReportResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ReportExternalTradeApiArg = {
  id: OrderId;
  executionOrderId: ExecutionOrderId;
  externalTradeReport: ExternalTradeReport;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteAllocationApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteAllocationApiArg = {
  id: AllocationId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllVenueConfigurationsApiResponse =
  /** status 200 Successful response */ ListAllVenueConfigurationsResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllVenueConfigurationsApiArg = void;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListBookingConfigurationsApiResponse =
  /** status 200 Successful response */ BookingConfiguration[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListBookingConfigurationsApiArg = {
  riskGroupId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateBookingConfigurationApiResponse =
  /** status 201 Successful response */ BookingConfiguration;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateBookingConfigurationApiArg = {
  createBookingConfigurationRequest: BookingConfiguration2;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateBookingConfigurationApiResponse =
  /** status 200 Successful response */ BookingConfiguration;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateBookingConfigurationApiArg = {
  updateBookingConfigurationRequest: UpdateBookingConfigurationRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteBookingConfigurationByIdApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteBookingConfigurationByIdApiArg = {
  id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ProposeExecutionInstructionApiResponse =
  /** status 200 Successful response */ ExecutionInstructionProposal;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ProposeExecutionInstructionApiArg = {
  body: {
    order: OrderRequest;
    /** Whether to test proposing an Execution Instruction */
    dry_run: boolean;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRulesetsApiResponse =
  /** status 200 Successful response */ ListAllRulesetsResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRulesetsApiArg = void;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertRulesetApiResponse =
  /** status 200 Dry run - Ruleset created successfully */
    | ExecutionInstructionDecisionTree
    | /** status 201 Ruleset created successfully */ ExecutionInstructionDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertRulesetApiArg = {
  upsertRulesetRequest: CreateRulesetRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRulesetApiResponse =
  /** status 200 Ruleset deleted successfully */ ExecutionInstructionDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRulesetApiArg = {
  id: string;
  scope: RulesetScope;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListSupportedExpressionsApiResponse =
  /** status 200 Successful response */ SupportedExpression[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListSupportedExpressionsApiArg = void;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllFeeScheduleRulesApiResponse =
  /** status 200 Successful response */ ListAllFeeScheduleRulesResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllFeeScheduleRulesApiArg = {
  riskGroupId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertFeeScheduleRulesApiResponse =
  /** status 200 Dry run - Fee Schedule Rules created successfully */
    | FeeDecisionTree
    | /** status 201 Fee Schedule Rules created successfully */ FeeDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertFeeScheduleRulesApiArg = {
  upsertFeeScheduleRulesRequest: UpsertFeeScheduleRulesRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteFeeScheduleRulesApiResponse =
  /** status 200 Fee Schedule Rules deleted successfully */ FeeDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteFeeScheduleRulesApiArg = {
  id: string;
  deleteFeeScheduleRulesRequest: DeleteFeeScheduleRulesRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRepFeeScheduleRulesApiResponse =
  /** status 200 Successful response */ ListAllRepFeeScheduleRulesResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRepFeeScheduleRulesApiArg = {
  riskGroupId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertRepFeeScheduleRulesApiResponse =
  /** status 200 Dry run - Rep Fee Schedule Rules validated successfully */
    | RepFeeDecisionTree
    | /** status 201 Rep Fee Schedule Rules created successfully */ RepFeeDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertRepFeeScheduleRulesApiArg = {
  upsertRepFeeScheduleRulesRequest: UpsertRepFeeScheduleRulesRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRepFeeScheduleRulesApiResponse =
  /** status 200 Rep Fee Schedule Rules deleted successfully */ RepFeeDecisionTree;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRepFeeScheduleRulesApiArg = {
  id: string;
  deleteRepFeeScheduleRulesRequest: DeleteRepFeeScheduleRulesRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetFeesForInstrumentApiResponse =
  /** status 200 Successful response */ GetFeesForInstrumentResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetFeesForInstrumentApiArg = {
  id: RiskGroupId;
  instrumentId: InstrumentId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostDefaultTraderForOrgApiResponse =
  /** status 201 Successful response */ OrgDefaultTraderUserIdResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostDefaultTraderForOrgApiArg = {
  /** The ID of the organization for which we're setting the default trader. */
  orgId: string;
  postDefaultTraderProfileForOrgRequest: PostDefaultTraderProfileForOrgRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetDefaultTraderForOrgApiResponse =
  /** status 200 Successful response */ OrgDefaultTraderUserIdResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetDefaultTraderForOrgApiArg = {
  /** The ID of the organization for which we're retrieving the default trader. */
  orgId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteDefaultTraderForOrgApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteDefaultTraderForOrgApiArg = {
  /** The ID of the organization for which we're deleting the default trader. */
  orgId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetTraderProfileApiResponse =
  /** status 200 Successful response */ TraderProfile;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetTraderProfileApiArg = {
  /** The organization ID under which the trader profile is to be retrieved. */
  orgId: string;
  /** The user ID of the trader whose profile is to be retrieved. */
  userId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateTraderProfileApiResponse =
  /** status 201 Successful response */ TraderProfile;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateTraderProfileApiArg = {
  /** The organization ID under which the trader profile is to be created. */
  orgId: string;
  /** The user ID of the trader whose profile is to be created. */
  userId: string;
  createTraderProfileRequest: CreateTraderProfileRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateTraderProfileApiResponse =
  /** status 201 Successful response */ TraderProfile;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateTraderProfileApiArg = {
  /** The organization ID under which the trader profile is to be updated. */
  orgId: string;
  /** The user ID of the trader whose profile is to be updated. */
  userId: string;
  updateTraderProfileRequest: UpdateTraderProfileRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteTraderProfileApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteTraderProfileApiArg = {
  /** The organization ID under which the trader profile is to be deleted. */
  orgId: string;
  /** The user ID of the trader whose profile is to be deleted. */
  userId: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderCostsApiResponse =
  /** status 200 Successful response */ OrderCostsResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderCostsApiArg = {
  /** Order costs calculation request */
  orderCostsRequest: OrderCostsRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateBatchListRfqWithAutoExApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateBatchListRfqWithAutoExApiArg = {
  createBatchListRfqRequest: CreateBatchListRfqRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRfqApiResponse = unknown;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRfqApiArg = {
  /** The id of the RFQ you wish to cancel. */
  id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateRfqApiResponse =
  /** status 201 Successful response */ CreateRfqResponse;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateRfqApiArg = {
  createRfq: CreateRfq;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderResponse = {
  /** Unique, Moment-generated ID for the allocation. */
  allocation_id?: string;
  id: OrderId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Schema = {
  /** Human-readable error message describing what went wrong. */
  error: string;
  /** Additional structured information about the error. */
  error_details?: any;
  /** High-level error category for programmatic error handling. */
  error_type:
    | "invalid_request"
    | "not_found"
    | "server_error"
    | "unauthorized"
    | "rate_limited"
    | "forbidden"
    | "closed"
    | "not_implemented"
    | "resource_conflict";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CustodianId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BookingType = "cash" | "margin";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllOrNone = boolean;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Amount = {
  value: number;
  type: "par" | "notional" | "shares";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AccountConfiguration = {
  /** Whether the prime brokerage is enabled for the account. */
  prime_brokerage_enabled?: boolean;
  /** The ID of the household for the account. */
  household_id?: string;
  /** The ID of the manager for the account. */
  manager_id?: string;
  custodian_id?: CustodianId;
  booking_type?: BookingType;
  /** The tax lot ID assigned by the custodian. */
  custodian_tax_lot_id?: string;
  /** Whether the introducing broker exercised discretion on behalf of the end client on this particular order. */
  is_discretionary?: boolean;
  /** Whether the order was solicited. Must be unset if the order is discretionary. */
  is_solicited?: boolean;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationRequest = {
  /** Strategy for allocation. Determines how the block's filled quantity is distributed across requested accounts.
    - `fifo_without_averaging`: allocates on a first-in, first-out basis without averaging; preserves individual trade prices per allocation.
    - `fifo_with_averaging`: allocates first-in, first-out and applies the block's average fill price to each allocation.
    - `pro_rata_with_averaging`: allocates pro-rata across requested accounts and applies the block's average fill price. Typically used for equity and ETF block orders.
    
    **RIA accounts must use `fifo_without_averaging`.** The averaging
    strategies (`fifo_with_averaging`, `pro_rata_with_averaging`) require a
    principal/averaging trading account to average executions before they are
    booked to client accounts. RIAs trade in an agency capacity and must report
    the actual street-execution prices and quantities to their custodian (e.g.
    Schwab), so each allocation has to match a real executed trade. Because there
    is no averaging account to absorb the difference, averaged allocation is not
    available to RIAs — only the non-averaging FIFO strategy, which preserves the
    true per-trade execution prices, is supported.
     */
  strategy:
    | "fifo_without_averaging"
    | "fifo_with_averaging"
    | "pro_rata_with_averaging";
  /** Client-provided ID for the allocation */
  client_allocation_id: string;
  /** Account allocations for an individual order */
  account_allocations: {
    /** Client-provided unique ID for the account allocation; for example, to cross-reference with an internal system. Values must be unique within the trading day. */
    client_account_allocation_id: string;
    /** Unique ID of user account */
    account_id: string;
    requested_amount: Amount;
    account_configuration?: AccountConfiguration;
    /** The Moment internal ID of the sleeve to allocate the order to. */
    moment_sleeve_id?: string;
  }[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Annotation = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ClientOrderId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CounterExpiryTime = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Protocol =
  | "limit_order_book"
  | "request_for_quote"
  | "external"
  | "group"
  | "custodian";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Strategy = "smart_order_routing" | "manual" | "report" | "auto_ex";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type LimitPrice = number | null;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type VenueTraderInfo = {
  /** The MPID of the venue. */
  venue_mpid: string;
  /** The ID of the custodian for the venue trader info. */
  custodian_id: string;
  /** The ID of the venue trader. */
  venue_trader_id: string;
  /** The ID of the custodian account for the venue trader. */
  custodian_account_at_venue: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqProtocolParameters = {
  /** The MPID of the venue. */
  venue_mpid: string;
  /** The type of the RFQ. */
  type: "bin" | "asap";
  /** The disclosure for the RFQ. Currently, only `disclosed` is supported. */
  disclosure: "disclosed" | "anonymous";
  /** Specifies how duration following RFQ creation, after which the RFQ becomes due. */
  due_after?: string;
  /** Specifies the duration following the due time (or submission time if no due time is defined) during which quotes are considered subject. */
  subject_after?: string;
  /** Specifies the duration following the latest of due time, subject time, or submission time, after which the RFQ expires. */
  expire_after?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionCriteria = {
  /** Minimum wait time for the execution order. */
  min_wait_time: string;
  /** Minimum number of quotes required on the side of the order, before execution can proceed. If the protocol is `request_for_quote`, this is the minimum number of RFQ quotes required. If the protocol is `limit_order_book`, this is the minimum number of LOB quotes required. */
  min_number_quotes: number;
  /** Maximum transaction cost in dollars. Max buy price = estimated price * par value + maxDollar, Min sell price = estimated price * par value - maxDollar. Ex. a value of `5` would mean the transaction cost must be within $5 of the instrument's estimated price in dollars, meaning when buying a bond with a estimated price of $100 and a par value of $1000, the transaction cost must be below $1005. */
  max_transaction_cost_dollar?: string;
  /** Maximum transaction cost in percent. Max buy price = estimated price * (1 + maxPct / 100), Min sell price = estimated price * (1 - maxPct / 100). Ex. a value of `5` would mean the transaction cost must be within 5% of the instrument's estimated price in percent, meaning when buying a bond with a estimated price of $100, the transaction cost must be below $105. */
  max_transaction_cost_percent?: string;
  /** Maximum transaction cost in yield. Max buy yield = estimated ytw - maxYTW, Max sell yield = estimated ytw + maxYTW. Ex. a value of `0.5` would mean the transaction cost must be within 50 bps of the instrument's estimated yield, meaning when buying a bond with an estimated yield to worst of 1.5%, the transaction cost must be above 1.0%. */
  max_transaction_cost_yield?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExitCriteria = {
  /** Timeout for the execution order. */
  timeout: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TraderIDs = {
  /** the Moment ID for this user */
  user_id: string;
  /** the registered Bloomberg ID for this user */
  bloomberg_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RulesetMetadata = {
  /** The ID of the proposal. */
  proposal_id: string;
  /** The version ID of the ruleset that auto generated the order. */
  tree_version_id: string;
} | null;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReport = {
  amount: Amount;
  /** Optional annotation for the trade. */
  annotation?: string | null;
  /** Flag to bypass street side leg. If true, we will not send the street side to the custodian. */
  bypass_street_side_leg?: boolean;
  /** Flag to bypass trade booking. If true, the trade will not be booked in the system. */
  bypass_trade_booking: boolean;
  /** The client-provided idempotency key. */
  client_external_trade_report_id: string;
  /** DTC ID of the counterparty's clearing firm. */
  counterparty_clearing_firm_id: string;
  /** MPID of the counterparty involved in the street trade. */
  counterparty_id: string;
  /** Trade ID. Often times this will be the ID of the execution made at an external venue. */
  execution_id?: string;
  /** Optional external trade report ID. If provided, this ID will be used instead of auto-generating one.
    Must start with 'etr_' followed by a valid ULID.
    If not provided, the system will generate a unique ID automatically.
     */
  external_trade_report_id?: string;
  /** The trade price. */
  price: number;
  /** The settlement date for the trade. */
  settle_date: string;
  /** Optional quote snapshot ID. If provided, this snapshot ID will be used instead of creating a new one. */
  snapshot_id?: string;
  /** The timestamp when the trade occurred. */
  trade_time: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Items = {
  /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytm instead. */
  yield_to_maturity?: number;
  /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytw instead. */
  yield_to_worst?: number;
  size: number;
  min_size: number;
  venue_mpid: string;
  spread_benchmark_isin?: string | null;
  spread_to_benchmark_bps?: string | null;
  min_balance_remaining?: number | null;
  min_increment?: number | null;
  source: "LOB" | "RFQ";
  pre_fee_price: number;
  post_fee_price: number;
  /** Pre-fee yield to worst (street price, no fees). */
  pre_fee_ytw: number;
  /** Post-fee yield to worst (inclusive of Moment fees). */
  post_fee_ytw: number;
  /** Pre-fee yield to maturity (street price, no fees). */
  pre_fee_ytm: number;
  /** Post-fee yield to maturity (inclusive of Moment fees). */
  post_fee_ytm: number;
  pre_fee_spread_bps?: number | null;
  post_fee_spread_bps?: number | null;
  side: "bid" | "ask";
  disabled: boolean;
  rfq_quote_status?: string;
  rfq_id?: string;
  venue_quote_id?: string;
  settlement_date: number;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type QuotesSnapshot = {
  isin: string;
  organization_id: string;
  bids: {
    /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytm instead. */
    yield_to_maturity?: number;
    /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytw instead. */
    yield_to_worst?: number;
    size: number;
    min_size: number;
    venue_mpid: string;
    spread_benchmark_isin?: string | null;
    spread_to_benchmark_bps?: string | null;
    min_balance_remaining?: number | null;
    min_increment?: number | null;
    source: "LOB" | "RFQ";
    pre_fee_price: number;
    post_fee_price: number;
    /** Pre-fee yield to worst (street price, no fees). */
    pre_fee_ytw: number;
    /** Post-fee yield to worst (inclusive of Moment fees). */
    post_fee_ytw: number;
    /** Pre-fee yield to maturity (street price, no fees). */
    pre_fee_ytm: number;
    /** Post-fee yield to maturity (inclusive of Moment fees). */
    post_fee_ytm: number;
    pre_fee_spread_bps?: number | null;
    post_fee_spread_bps?: number | null;
    side: "bid" | "ask";
    disabled: boolean;
    rfq_quote_status?: string;
    rfq_id?: string;
    venue_quote_id?: string;
    settlement_date: number;
  }[];
  asks: Items[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExtendedHours = boolean;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Decimal = number | string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type NullableDecimal = ((number | null) | (string | null)) | null;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type FeeAmountType =
  | "percentage_of_par"
  | "percentage_of_market_value"
  | "yield_bps";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type IntroducingBrokerId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type InstrumentId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RiskGroupId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderRequest = {
  /** Deprecated, will be removed soon. Use account_configuration.booking_type instead. */
  account_booking_type?: "cash" | "margin";
  /** Account configuration for the allocation */
  account_configuration?: {
    /** Whether the prime brokerage is enabled for the account. */
    prime_brokerage_enabled?: boolean;
    /** The ID of the household for the account. */
    household_id?: string;
    /** The ID of the manager for the account. */
    manager_id?: string;
    custodian_id?: CustodianId;
    booking_type?: BookingType;
    /** The tax lot ID assigned by the custodian. */
    custodian_tax_lot_id?: string;
    /** Whether the introducing broker exercised discretion on behalf of the end client on this particular order. */
    is_discretionary?: boolean;
    /** Whether the order was solicited. Must be unset if the order is discretionary. */
    is_solicited?: boolean;
  };
  /** Unique ID of user account */
  account_id?: string | null;
  all_or_none?: AllOrNone;
  /** Allocations for the order */
  allocations?: AllocationRequest;
  /** The Amount of an order with a specified `type` indicating how the amount is represented.
    - **Par:** Represents the order size in face value (e.g., a corporate bond with a $1,000 face value).
    - **Notional:** Represents the order size in notional dollar value.
    - **Shares:** Represents the order size in number of shares (for equities). */
  amount: {
    value: number;
    type: "par" | "notional" | "shares";
  };
  annotation?: Annotation;
  /** Client-provided information to configure trade booking for the order, as a map from string to string. Passing a multi-layer JSON map or something other than "string":"string" key-value pairs will result in an error. The specific contents of this field should be determined in conjunction with the back-office integration. */
  booking_instructions?: {
    [key: string]: string;
  };
  /** Flag to indicate if auto execution rules should be bypassed */
  bypass_auto_execution?: boolean;
  client_order_id: ClientOrderId;
  /** The time until which the counter is valid */
  counter_expiry_time?: CounterExpiryTime;
  /** The ID of the custodian for the order. Custodians must be enabled per risk group. */
  custodian_id?: string;
  /** A list of execution instructions for the order */
  execution_instructions?: {
    /** The client-provided ID for the execution order. */
    client_execution_order_id: string;
    protocol: Protocol;
    strategy: Strategy;
    quantity: Amount;
    limit_price?: LimitPrice;
    /** Metadata related to the RFQ. */
    rfq_metadata?: {
      /** The ID of the RFQ. */
      moment_rfq_id?: string;
      /** The ID of the contra quote for the RFQ. */
      contra_quote_id?: string;
    };
    /** Flag to toggle if the Prevailing Market Price (PMP) check should be suppressed for the execution order. */
    suppress_pmp_check?: boolean;
    /** A list of venue trader info for the execution order. */
    venue_trader_info?: VenueTraderInfo[];
    /** A list of RFQ protocol parameters for the execution order. */
    rfq_protocol_parameters?: RfqProtocolParameters[];
    execution_criteria?: ExecutionCriteria;
    exit_criteria?: ExitCriteria;
    /** MPID of the venue to trade on. */
    venue_mpid?: string;
    /** Only for auto-RFQ orders, flag to determine whether to skip matching against the limit order book quotes and only match against RFQ quotes. Must be set if the protocol is `request_for_quote` and the strategy is `auto_ex`. */
    skip_lob_quotes?: boolean;
    /** Flag to indicate whether the order should be executed as an all-or-none order. If set to true, the order will only be executed if the entire quantity can be filled. */
    all_or_none?: boolean;
    /** The trader assigned to this execution instruction. */
    trader_profile?: TraderIDs;
    /** Metadata about the ruleset that auto generated the order. */
    ruleset_metadata?: RulesetMetadata;
    /** Flag to indicate if the order is a counter */
    is_counter?: boolean;
    /** Duration in seconds until which the counter is valid */
    counter_expires_after?: string | null;
    external_trade_report?: ExternalTradeReport;
    quotes_snapshot?: QuotesSnapshot;
  }[];
  /** Deprecated. The value provided here is ignored — orders are always
    treated as if explicit cancellation is required. The field is kept
    for backwards compatibility and will be removed in a future release.
     */
  explicit_cancelation_required?: boolean;
  extended_hours?: ExtendedHours;
  /** Custom fees to be applied to the order. If provided, this list overrides the default fees defined in the system.
    
    For each fee recipient based on the trade structure, a separate fee object should be included.
    For example, in a trade flow like:
    
      Street <-> Executing Broker <-> Introducing Broker <-> Customer
    
    where both brokers are charging fees, you would specify:
    
      "fees": [
        {
          "fee_type": "markup",
          "fee_amount_type": "percentage_of_par",
          "fee_amount": 0.01,
          "recipient": "<org_id_of_executing_broker>"
        },
        {
          "fee_type": "markup",
          "fee_amount_type": "percentage_of_par",
          "fee_amount": 0.05,
          "recipient": "<org_id_of_introducing_broker>"
        }
      ]
     */
  fees?: {
    /** The type of fee to apply to the order. Valid values are "markup", "commission", and "sales_credit". */
    fee_type: "markup" | "commission" | "sales_credit";
    /** The method used to calculate the fee amount. Supported types include:
        
        - `percentage_of_par`: Fee as a percentage of par value.
          Example: `0.10` = 10 basis points of par value.
        
        - `percentage_of_market_value`: Fee as a percentage of the quote price (market value).
          Example: `1` = 1% of market value.
        
        - `yield_bps`: Fee expressed in yield terms, in basis points.
          Example: `100` = 100 basis points of yield.
         */
    fee_amount_type:
      | "percentage_of_par"
      | "percentage_of_market_value"
      | "yield_bps";
    /** Unique ID of the recipient of the fee. */
    recipient_id?: string;
    /** The type of recipient for the fee. */
    recipient_type?:
      | "executing_broker"
      | "introducing_broker"
      | "advisor"
      | "customer";
    /** Fee amount to apply to the order. */
    fee_amount: Decimal;
    /** Maximum fee amount to apply to the order. */
    max_fee_amount?: NullableDecimal;
    max_fee_amount_type?: FeeAmountType;
    /** Optional name for the fee, for easier identification. */
    fee_name?: string;
  }[];
  /** Flag to indicate if the order is for a block trade, used for post order allocation */
  for_block_trade?: boolean | null;
  /** List of group members for the order */
  group_members?: {
    /** The ID of the order in the group */
    moment_order_id: string;
  }[];
  /** The introducing broker ID to use for this specific order. If not specified, will use the introducing broker ID from the bulk request. */
  ib_id?: IntroducingBrokerId;
  instrument_id: InstrumentId;
  /** Flag to indicate if the order is a counter */
  is_counter?: boolean;
  /** Flag to indicate if the order is a group order */
  is_group_order?: boolean;
  /** The Percentage Price is represented as a percentage of par. For a typical $1,000 par value bond, a percentage price of $90 values the bond at $900. This is a clean price, which does not include accrued interest. */
  limit_price?: number | null;
  /** Custom metadata for the order. This can be used to store additional information about the order that is not covered by the other fields. The keys and values are both strings. */
  metadata?: {
    [key: string]: string;
  } | null;
  /** A list of existing RFQ IDs to associate with this order. */
  order_rfq_ids?: string[];
  /** Reason for why the order requires review. Only applicable when review_required is true. */
  review_reason?: string;
  /** Flag to indicate if the order requires manual review before execution. */
  review_required?: boolean;
  /** The risk group ID to use for this specific order. If not specified, will use the risk group ID from the bulk request. */
  risk_group_id?: RiskGroupId;
  /** The targeted settlement date for the order in the format of YYYYMMDD, like 20090101 */
  settlement_date?: number | null;
  /** Represents which side this order is on:
    
    - buy
    - sell */
  side: "buy" | "sell";
  /** Represents the types of orders Moment currently supports.

    - limit
    - rfq_response
    - market
    - advisor_bw
    - quote_wanted */
  type: "limit" | "rfq_response" | "market" | "advisor_bw" | "quote_wanted";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostOrderAllocationRequest = {
  allocations: {
    /** Strategy for allocation. Determines how the block's filled quantity is distributed across requested accounts.
        - `fifo_without_averaging`: allocates on a first-in, first-out basis without averaging; preserves individual trade prices per allocation.
        - `fifo_with_averaging`: allocates first-in, first-out and applies the block's average fill price to each allocation.
        - `pro_rata_with_averaging`: allocates pro-rata across requested accounts and applies the block's average fill price. Typically used for equity and ETF block orders.
        
        **RIA accounts must use `fifo_without_averaging`.** The averaging
        strategies (`fifo_with_averaging`, `pro_rata_with_averaging`) require a
        principal/averaging trading account to average executions before they are
        booked to client accounts. RIAs trade in an agency capacity and must report
        the actual street-execution prices and quantities to their custodian (e.g.
        Schwab), so each allocation has to match a real executed trade. Because there
        is no averaging account to absorb the difference, averaged allocation is not
        available to RIAs — only the non-averaging FIFO strategy, which preserves the
        true per-trade execution prices, is supported.
         */
    strategy:
      | "fifo_without_averaging"
      | "fifo_with_averaging"
      | "pro_rata_with_averaging";
    /** Client-provided ID for the allocation */
    client_allocation_id: string;
    /** Account allocations for an individual order */
    account_allocations: {
      /** Client-provided unique ID for the account allocation; for example, to cross-reference with an internal system. Values must be unique within the trading day. */
      client_account_allocation_id: string;
      /** Unique ID of user account */
      account_id: string;
      requested_amount: Amount;
      account_configuration?: AccountConfiguration;
      /** The Moment internal ID of the sleeve to allocate the order to. */
      moment_sleeve_id?: string;
    }[];
  };
  client_order_id: ClientOrderId;
  /** Optional ISIN of the instrument being allocated. When provided, the asset class is resolved from refdata and used to select the matching booking configuration; when omitted, allocation resolves to a wildcard booking configuration. */
  isin?: string;
  risk_group_id: RiskGroupId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderSide = "buy" | "sell";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderType = "limit" | "rfq_response" | "market";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RequestEventEventPayload = {
  /** Unique ID of user account */
  account_id?: string;
  amount?: Amount;
  /** Client-provided custom metadata for the order. */
  annotation?: string;
  client_order_id?: string;
  cusip?: string;
  event_type?: "request";
  extended_hours?: boolean;
  isin?: string;
  limit_price?: LimitPrice;
  order_id?: string;
  risk_group_id?: string;
  side?: OrderSide;
  time?: string;
  type?: OrderType;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type EventId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type MessageNumber = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RequestEvent = {
  event?: RequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  /** The type of message. */
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RejectEventEventPayload = {
  client_order_id?: string;
  event_type?: "reject";
  order_id?: string;
  reject_code?: number;
  reject_reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RejectEvent = {
  event?: RejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ApproveEventEventPayload = {
  client_order_id?: string;
  event_type?: "approve";
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ApproveEvent = {
  event?: ApproveEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelEventEventPayload = {
  cancel_code?: number;
  cancel_reason?: string;
  client_order_id?: string;
  event_type?: "cancel";
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelEvent = {
  event?: CancelEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionEventEventPayload = {
  accrued_interest?: number;
  amount?: Amount;
  client_order_id?: string;
  /** The market participant identifier (MPID) */
  counterparty?: string;
  /** The National Securities Clearing Corporation (NSCC) id */
  counterparty_clearing_firm?: string;
  event_type?: "execution";
  execution_order_id?: ExecutionOrderId;
  net_money?: number;
  order_id?: string;
  pre_fee_net_money?: number;
  pre_fee_price?: LimitPrice;
  price?: LimitPrice;
  settlement_date?: string;
  time?: string;
  trade_date?: string;
  venue?: string;
  venue_execution_id?: string;
  ytm?: number | null;
  ytw?: number | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionEvent = {
  event?: ExecutionEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationStrategy =
  | "fifo_without_averaging"
  | "fifo_with_averaging"
  | "pro_rata_with_averaging";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ClientAllocationId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCreateEventEventPayload = {
  allocation_id?: AllocationId;
  allocation_strategy?: AllocationStrategy;
  client_allocation_id?: ClientAllocationId;
  client_order_id?: string;
  custodian_id?: string;
  event_type?: "allocation_create";
  ib_id?: IntroducingBrokerId;
  order_id?: string;
  risk_group_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AccountId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AccountAllocationDetails = {
  account_id?: AccountId;
  /** The pro-rated coupon payment that will be either paid or received when the trade is settled. Expressed in USD. */
  accrued_interest?: number;
  actual_amount?: Amount;
  /** Client-provided unique ID for the account allocation; for example, to cross-reference with an internal system. Values must be unique within the trading day. */
  client_account_allocation_id?: string;
  fill_price?: LimitPrice;
  /** Actual cash flow of the order. */
  net_money?: number;
  /** Net money of the order before fees are applied. */
  pre_fee_net_money?: number;
  requested_amount?: Amount;
  /** The identifier for the trade as provided by the venue. */
  venue_execution_id?: string;
  /** The Market Participant Identifier (MPID) of the venue where the trade was executed. */
  venue_mpid?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AccountAllocationRequest = {
  account_configuration?: AccountConfiguration;
  account_id?: AccountId;
  /** Client-provided unique ID for the account allocation; for example, to cross-reference with an internal system. Values must be unique within the trading day. */
  client_account_allocation_id?: string;
  /** The ID of the custodian for the account allocation. */
  custodian_id?: string;
  requested_amount?: Amount;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationStatus =
  | "created"
  | "approved"
  | "rejected"
  | "calculated"
  | "submitted"
  | "failed"
  | "canceled";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationTrade = {
  /** The pro-rated coupon payment that will be either paid or received when the trade is settled. Expressed in USD. */
  accrued_interest?: number;
  amount?: Amount;
  /** Actual cash flow of the order. */
  net_money?: number;
  /** Net money of the order before fees are applied. */
  pre_fee_net_money?: number;
  price?: LimitPrice;
  /** The identifier for the trade as provided by the venue. */
  venue_execution_id?: string;
  /** The Market Participant Identifier (MPID) of the venue where the trade was executed. */
  venue_mpid?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationSummary = {
  account_allocations?: AccountAllocationDetails[];
  account_requests?: AccountAllocationRequest[];
  /** The time at which the allocation was calculated. */
  calculated_at?: string | null;
  /** Client-provided unique ID for the allocation; for example, to cross-reference with an internal system. Values must be unique within the trading day. */
  client_allocation_id?: string;
  /** Client-provided unique ID for the order; for example, to cross-reference with an internal system. Must be unique within the trading day, otherwise duplicate orders will be rejected during pre-trade checks. */
  client_order_id?: string;
  custodian_id?: CustodianId;
  ib_id?: IntroducingBrokerId;
  id?: AllocationId;
  order_id?: OrderId;
  /** The risk group ID used for this allocation. */
  risk_group_id?: string;
  status?: AllocationStatus;
  strategy?: AllocationStrategy;
  /** The time at which the allocation was submitted to the custodian for booking. */
  submitted_at?: string | null;
  trades?: AllocationTrade[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCreateEvent = {
  event?: AllocationCreateEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationRejectEventEventPayload = {
  allocation_id?: AllocationId;
  client_allocation_id?: ClientAllocationId;
  code?: number;
  event_type?: "allocation_reject";
  reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationRejectEvent = {
  event?: AllocationRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationApproveEventEventPayload = {
  allocation_id?: AllocationId;
  client_allocation_id?: ClientAllocationId;
  event_type?: "allocation_approve";
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationApproveEvent = {
  event?: AllocationApproveEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCancelEventEventPayload = {
  allocation_id?: AllocationId;
  client_allocation_id?: ClientAllocationId;
  code?: number;
  event_type?: "allocation_cancel";
  reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCancelEvent = {
  event?: AllocationCancelEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCalculateEventEventPayload = {
  account_allocations?: AccountAllocationDetails[];
  allocation_id?: AllocationId;
  allocation_strategy?: AllocationStrategy;
  client_allocation_id?: ClientAllocationId;
  client_order_id?: string;
  custodian_id?: string;
  event_type?: "allocation_calculate";
  ib_id?: string;
  order_id?: string;
  risk_group_id?: string;
  time?: string;
  trades?: AllocationTrade[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationCalculateEvent = {
  event?: AllocationCalculateEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationSubmitEventEventPayload = {
  allocation_id?: AllocationId;
  client_allocation_id?: ClientAllocationId;
  custodian_id?: string;
  event_type?: "allocation_submit";
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationSubmitEvent = {
  event?: AllocationSubmitEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationFailEventEventPayload = {
  allocation_id?: AllocationId;
  client_allocation_id?: ClientAllocationId;
  /** The error code for the failure. */
  code?: number;
  event_type?: "allocation_fail";
  /** The reason for the failure. */
  reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AllocationFailEvent = {
  event?: AllocationFailEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "allocation_update";
  summary?: AllocationSummary;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelRequestEventEventPayload = {
  cancel_request_id?: string;
  event_type?: "cancel_request";
  order_id?: string;
  risk_group_id?: string;
  source?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelRequestEvent = {
  event?: CancelRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelRejectEventEventPayload = {
  cancel_reject_code?: number;
  cancel_reject_reason?: string;
  cancel_request_id?: string;
  event_type?: "cancel_reject";
  order_id?: string;
  risk_group_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelRejectEvent = {
  event?: CancelRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelAllocationRequestEventEventPayload = {
  allocation_id?: AllocationId;
  cancel_request_id?: string;
  event_type?: "cancel_allocation_request";
  /** The ID of the parent order. */
  order_id?: string;
  source?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelAllocationRequestEvent = {
  event?: CancelAllocationRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelAllocationRejectEventEventPayload = {
  allocation_id?: AllocationId;
  cancel_reject_code?: number;
  cancel_reject_reason?: string;
  cancel_request_id?: string;
  event_type?: "cancel_allocation_reject";
  /** The ID of the parent order. */
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelAllocationRejectEvent = {
  event?: CancelAllocationRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type FlaggedForReviewEventEventPayload = {
  client_order_id?: ClientOrderId;
  event_type?: "flagged_for_review";
  failed_controls?: {
    /** The message of the control that failed. */
    control_message?: string;
  }[];
  /** The ID of the order that was flagged. */
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type FlaggedForReviewEvent = {
  event?: FlaggedForReviewEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveRequestEventEventPayload = {
  /** The annotation to be added to the order for the approval. */
  annotation?: string;
  /** The client-provided ID of the manual approval request. */
  client_manual_approve_id?: string;
  event_type?: "manual_approve_request";
  /** The ID of the manual approval request. */
  manual_approve_id?: string;
  /** The ID of the order to be approved. */
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveRequestEvent = {
  event?: ManualApproveRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveFailureEventEventPayload = {
  event_type?: "manual_approve_fail";
  /** The ID of the manual approval request. */
  manual_approve_id?: string;
  /** The ID of the order. */
  order_id?: string;
  /** The reason for the failure. */
  reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveFailureEvent = {
  event?: ManualApproveFailureEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectRequestEventEventPayload = {
  /** The annotation to be added to the order for the rejection. */
  annotation?: string;
  /** The client-provided ID of the manual reject request. */
  client_manual_reject_id?: string;
  event_type?: "manual_reject_request";
  /** The ID of the manual reject request. */
  manual_reject_id?: string;
  /** The ID of the order to be rejected. */
  order_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectRequestEvent = {
  event?: ManualRejectRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectFailureEventEventPayload = {
  event_type?: "manual_reject_fail";
  /** The ID of the manual reject request. */
  manual_reject_id?: string;
  /** The ID of the order. */
  order_id?: string;
  /** The reason for the failure. */
  reason?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectFailureEvent = {
  event?: ManualRejectFailureEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportRequestEventEventPayload = {
  amount?: Amount;
  /** Optional annotation for the trade. */
  annotation?: string | null;
  /** Flag to bypass trade booking. */
  bypass_trade_booking?: boolean | null;
  /** The client-provided idempotency key. */
  client_external_trade_report_id?: string;
  /** NSCC ID of the counterparty's clearing firm. */
  counterparty_clearing_firm_id?: string;
  /** MPID of the counterparty involved in the street trade. */
  counterparty_id?: string;
  event_type?: "external_trade_report_request";
  /** Trade ID. Often times this will be the ID of the execution made at an external venue. */
  execution_id?: string;
  external_trade_report_id?: ExternalTradeReportId;
  /** The ID of the order. */
  order_id?: string;
  /** The trade price. */
  price?: number;
  /** The settlement date for the trade. */
  settle_date?: string;
  time?: string;
  /** The timestamp when the trade occurred. */
  trade_time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportRequestEvent = {
  event?: ExternalTradeReportRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportRejectEventEventPayload = {
  /** The client-provided idempotency key. */
  client_external_trade_report_id?: string;
  event_type?: "external_trade_report_reject";
  external_trade_report_id?: ExternalTradeReportId;
  /** The ID of the order. */
  order_id?: string;
  /** The reason for the rejection. */
  reason?: string;
  /** The time when the failure occurred. */
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportRejectEvent = {
  event?: ExternalTradeReportRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderRfq = {
  /** The ID of the RFQ that initiated the order request. */
  id: string;
  /** The ID of the quote that is being traded against. */
  contra_quote_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestEventEventPayload = {
  amount?: Amount;
  /** Idempotency key for the execution order request. */
  client_execution_order_id?: string;
  event_type?: "execution_order_request";
  execution_order_id?: ExecutionOrderId;
  /** The ID of the parent order. */
  order_id?: string;
  rfq?: OrderRfq;
  /** The time when the request was received. */
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestEvent = {
  event?: ExecutionOrderRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRejectEventEventPayload = {
  /** The client-provided execution order ID. */
  client_execution_order_id?: string;
  event_type?: "execution_order_reject";
  execution_order_id?: ExecutionOrderId;
  /** The ID of the parent order. */
  order_id?: string;
  /** The reason for the rejection. */
  reason?: string;
  /** The time when the failure occurred. */
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRejectEvent = {
  event?: ExecutionOrderRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type SuppressPmpCheck = boolean;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCreateEventEventPayload = {
  amount?: Amount;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  event_type?: "execution_order_create";
  execution_order_id?: ExecutionOrderId;
  limit_price?: LimitPrice;
  /** The protocol used for the execution order. */
  protocol?:
    | "limit_order_book"
    | "request_for_quote"
    | "external"
    | "group"
    | "custodian";
  rfq?: OrderRfq;
  /** The strategy used for the execution order. */
  strategy?: "smart_order_routing" | "manual" | "report" | "auto_ex";
  suppress_pmp_check?: SuppressPmpCheck;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCreateEvent = {
  event?: ExecutionOrderCreateEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCancelRequestEventEventPayload = {
  event_type?: "execution_order_cancel_request";
  /** The ID of the cancel request. */
  execution_order_cancel_request_id?: string;
  execution_order_id?: ExecutionOrderId;
  /** The ID of the parent order. */
  order_id?: string;
  /** The time when the cancellation request was received. */
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelExecutionOrderRequestEvent = {
  event?: ExecutionOrderCancelRequestEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCancelRejectEventEventPayload = {
  event_type?: "execution_order_cancel_reject";
  /** The ID of the cancel request. */
  execution_order_cancel_request_id?: string;
  execution_order_id?: ExecutionOrderId;
  /** The ID of the parent order. */
  order_id?: string;
  /** The reason for the rejection. */
  reason?: string;
  /** The time when the failure occurred. */
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CancelExecutionOrderRejectEvent = {
  event?: ExecutionOrderCancelRejectEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "system_update";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCancelEventEventPayload = {
  cancel_code?: number;
  cancel_reason?: string;
  client_execution_order_id?: string;
  event_type?: "execution_order_cancel";
  execution_order_id?: ExecutionOrderId;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderCancelEvent = {
  event?: ExecutionOrderCancelEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqCreateEventEventPayload = {
  event_type?: "rfq_create";
  order_id?: OrderId;
  /** The ID of the RFQ created on the order. */
  rfq_id?: string;
  time?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqCreateEvent = {
  event?: RfqCreateEventEventPayload;
  event_id?: EventId;
  msg_number?: MessageNumber;
  msg_type?: "order_update";
  order?: OrderRequest;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type EventData =
  | RequestEvent
  | RejectEvent
  | ApproveEvent
  | CancelEvent
  | ExecutionEvent
  | AllocationCreateEvent
  | AllocationRejectEvent
  | AllocationApproveEvent
  | AllocationCancelEvent
  | AllocationCalculateEvent
  | AllocationSubmitEvent
  | AllocationFailEvent
  | CancelRequestEvent
  | CancelRejectEvent
  | CancelAllocationRequestEvent
  | CancelAllocationRejectEvent
  | FlaggedForReviewEvent
  | ManualApproveRequestEvent
  | ManualApproveFailureEvent
  | ManualRejectRequestEvent
  | ManualRejectFailureEvent
  | ExternalTradeReportRequestEvent
  | ExternalTradeReportRejectEvent
  | ExecutionOrderRequestEvent
  | ExecutionOrderRejectEvent
  | ExecutionOrderCreateEvent
  | CancelExecutionOrderRequestEvent
  | CancelExecutionOrderRejectEvent
  | ExecutionOrderCancelEvent
  | RfqCreateEvent;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type EventType =
  | "request"
  | "approve"
  | "reject"
  | "flagged_for_review"
  | "manual_approve_request"
  | "manual_approve_fail"
  | "manual_reject_request"
  | "manual_reject_fail"
  | "cancel"
  | "execution"
  | "cancel_request"
  | "cancel_reject"
  | "execution_order_request"
  | "execution_order_reject"
  | "execution_order_create"
  | "execution_order_cancel_request"
  | "execution_order_cancel_reject"
  | "execution_order_cancel"
  | "cancel_allocation_request"
  | "cancel_allocation_reject"
  | "external_trade_report_request"
  | "external_trade_report_reject"
  | "rfq_create"
  | "allocation_create"
  | "allocation_reject"
  | "allocation_approve"
  | "allocation_cancel"
  | "allocation_calculate"
  | "allocation_submit"
  | "allocation_fail";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type IDs = {
  /** The ID of the allocation */
  allocation_id?: string;
  /** Client-provided unique ID for the order */
  client_order_id: string;
  /** The ID of the order */
  order_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkOrderSubmissionResponse = IDs[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkOrderSubmissionRequest = {
  ib_id?: IntroducingBrokerId;
  /** A list of individual orders used in a bulk submission */
  orders: OrderRequest[];
  risk_group_id?: RiskGroupId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkCancelOrderResult = {
  /** ID of the cancel request published to the sequencer. Present when status is `submitted`. */
  cancel_request_id?: string;
  /** The Moment order ID supplied in the request. */
  order_id: string;
  /** Human-readable reason. Present when status is `rejected` or `failed`. */
  reason?: string;
  /** `submitted` if the cancel request was published; `rejected` if the request was refused (e.g. malformed ID); `failed` if a downstream infrastructure error prevented us from publishing it. */
  status: "submitted" | "rejected" | "failed";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkCancelOrdersResponse = {
  results: BulkCancelOrderResult[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BulkCancelOrdersRequest = {
  /** When true, cancel the open quantity of every member of any group parent order in the batch along with the parent. Only valid for group parent orders; otherwise that order's cancel is rejected. */
  cancel_group_members?: boolean;
  /** List of Moment order IDs (ULID) to cancel. */
  order_ids: string[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualApproveResponse = {
  id: ManualApproveId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ManualRejectResponse = {
  id: ManualRejectId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderResponse = {
  execution_order_id: ExecutionOrderId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Fee = {
  /** The type of fee to apply to the order. Valid values are "markup", "commission", and "sales_credit". */
  fee_type: "markup" | "commission" | "sales_credit";
  /** The method used to calculate the fee amount. Supported types include:
    
    - `percentage_of_par`: Fee as a percentage of par value.
      Example: `0.10` = 10 basis points of par value.
    
    - `percentage_of_market_value`: Fee as a percentage of the quote price (market value).
      Example: `1` = 1% of market value.
    
    - `yield_bps`: Fee expressed in yield terms, in basis points.
      Example: `100` = 100 basis points of yield.
     */
  fee_amount_type:
    | "percentage_of_par"
    | "percentage_of_market_value"
    | "yield_bps";
  /** Unique ID of the recipient of the fee. */
  recipient_id?: string;
  /** The type of recipient for the fee. */
  recipient_type?:
    | "executing_broker"
    | "introducing_broker"
    | "advisor"
    | "customer";
  /** Fee amount to apply to the order. */
  fee_amount: Decimal;
  /** Maximum fee amount to apply to the order. */
  max_fee_amount?: NullableDecimal;
  max_fee_amount_type?: FeeAmountType;
  /** Optional name for the fee, for easier identification. */
  fee_name?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestLobsor = {
  /** Flag to indicate if the order should be executed as an All or None order. */
  all_or_none?: boolean;
  amount: Amount;
  /** Optional annotation for the execution order. */
  annotation?: string | null;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  fees?: Fee[];
  /** Limit price of the execution order request. If omitted, the order will inherit the limit price of the order, if exists. */
  limit_price?: number | null;
  /** Flag to toggle if the Prevailing Market Price (PMP) check should be suppressed for the execution order. */
  suppress_pmp_check?: boolean;
  /** an option to supply with a new trader ID */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestLobManual = ExecutionOrderRequestLobsor & {
  quotes_snapshot?: QuotesSnapshot;
  /** The MPID of the venue trader to use for the execution order. */
  venue_mpid: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type WouldParameters = {
  /** Per-share "I-Would" trigger price. */
  price?: {
    value: number;
    type: "per_share";
  };
  /** Share-count trigger: complete this many shares once the trigger price is reached. */
  trigger_quantity?: Amount;
  /** Percentage of the order quantity to complete when the trigger price is reached. */
  trigger_percent?: number | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AggressivenessLevel = "passive" | "neutral" | "aggressive";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TwapParameters = {
  /** Start of the absolute window to work the order. */
  start_time?: string;
  /** End of the absolute window to work the order. */
  end_time?: string;
  /** Whether the algo should participate in the opening auction. */
  participate_opening_auction?: boolean;
  /** Whether the algo should participate in the closing auction. */
  participate_closing_auction?: boolean;
  would?: WouldParameters;
  aggressiveness?: AggressivenessLevel;
  /** Hard ceiling on participation of market volume, as a percent (e.g. 20 = 20%). */
  max_participation_percent?: number | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type VwapParameters = {
  /** Start of the absolute window to work the order. */
  start_time?: string;
  /** End of the absolute window to work the order. */
  end_time?: string;
  /** Whether the algo should participate in the opening auction. */
  participate_opening_auction?: boolean;
  /** Whether the algo should participate in the closing auction. */
  participate_closing_auction?: boolean;
  would?: WouldParameters;
  aggressiveness?: AggressivenessLevel;
  /** Hard ceiling on participation of market volume, as a percent (e.g. 20 = 20%). */
  max_participation_percent?: number | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PovParameters = {
  /** Target participation rate of market volume, as a percent (e.g. 20 = 20%). */
  target_participation_percent: number;
  /** Hard ceiling on participation, distinct from the target percent. */
  max_participation_percent?: number | null;
  /** Start of the absolute window to work the order. */
  start_time?: string;
  /** End of the absolute window to work the order. */
  end_time?: string;
  /** Whether the algo should participate in the opening auction. */
  participate_opening_auction?: boolean;
  /** Whether the algo should participate in the closing auction. */
  participate_closing_auction?: boolean;
  would?: WouldParameters;
  aggressiveness?: AggressivenessLevel;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type IsParameters = {
  /** Start of the absolute window to work the order. */
  start_time?: string;
  /** End of the absolute window to work the order. */
  end_time?: string;
  /** Whether the algo should participate in the opening auction. */
  participate_opening_auction?: boolean;
  /** Whether the algo should participate in the closing auction. */
  participate_closing_auction?: boolean;
  would?: WouldParameters;
  aggressiveness?: AggressivenessLevel;
  /** Hard ceiling on participation of market volume, as a percent (e.g. 20 = 20%). */
  max_participation_percent?: number | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AlgoParameters = {
  twap?: TwapParameters;
  vwap?: VwapParameters;
  pov?: PovParameters;
  is?: IsParameters;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestCustodianManual = {
  /** Flag to indicate if the order should be executed as an All or None order. */
  all_or_none?: boolean;
  algo_parameters?: AlgoParameters;
  amount: Amount;
  /** Optional annotation for the execution order. */
  annotation?: string | null;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  /** Custodian ID for direct-to-custodian execution order routing. */
  custodian_id: "cust_apex" | "cust_fidelity" | "cust_pershing" | "cust_schwab";
  /** Identifier of the parent order instrument (ISIN, CUSIP, or ticker). Used together with side and the latest market price to derive a 2% collar limit price when limit_price is omitted on an equity or fund order. */
  instrument_id: string;
  /** Limit price (per share) of the execution order request. If omitted on an equity or fund order, a 2% collar limit price is derived from the latest market price (buy: market*1.02, sell: market*0.98) using instrument_id and side. */
  limit_price?: number | null;
  /** Side of the parent order. Used together with instrument_id to apply the collar in the correct direction when limit_price is omitted. */
  side: OrderSide;
  /** Flag to toggle if the Prevailing Market Price (PMP) check should be suppressed for the execution order. */
  suppress_pmp_check?: boolean;
  /** an option to supply with a new trader ID */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestManualRfq = {
  /** Flag to indicate if the order should be executed as an All or None order. */
  all_or_none?: boolean;
  amount: Amount;
  /** Optional annotation for the execution order. */
  annotation?: string | null;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  /** Duration in seconds until which the counter is valid */
  counter_expiry_time?: string | null;
  /** Price of the counter. If is_counter is true, this field is required. */
  counter_price?: {
    /** Decimal number. */
    value: number | string;
    /** The method used to represent the price value. */
    type:
      | "percent"
      | "discount_yield"
      | "spread"
      | "money_market_yield"
      | "per_share";
    /** The ISIN of the benchmark security, required when type is 'spread'. */
    benchmark_isin?: string | null;
  };
  fees?: Fee[];
  /** Flag to indicate if the order is a counter */
  is_counter?: boolean;
  quotes_snapshot?: QuotesSnapshot;
  /** Contains the required information about the RFQ that prompted the order. */
  rfq: {
    /** The ID of the RFQ that initiated the order request. */
    id: string;
    /** The ID of the quote that is being traded against. */
    contra_quote_id: string;
  };
  /** an option to supply with a new trader ID */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestAutoExRfq = {
  /** Flag to indicate if the order should be executed as an All or None order. */
  all_or_none?: boolean;
  amount: Amount;
  /** Optional annotation for the execution order. */
  annotation?: string | null;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  execution_criteria: ExecutionCriteria;
  exit_criteria?: ExitCriteria;
  fees?: Fee[];
  /** Limit price of the execution order request. If omitted, the order will inherit the limit price of the order, if exists. */
  limit_price?: number | null;
  rfq_protocol_parameters: RfqProtocolParameters[];
  /** Flag to indicate whether to skip matching LOB quotes and only use RFQ quotes. */
  skip_lob_quotes: boolean;
  /** an option to supply with a new trader ID */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionOrderRequestExternal = {
  amount: Amount;
  /** Optional annotation for the execution order. */
  annotation?: string | null;
  /** Idempotency key for the execution order request. */
  client_execution_order_id: string;
  external_trade_report?: {
    amount: Amount;
    /** Optional annotation for the trade. */
    annotation?: string | null;
    /** Flag to bypass street side leg. If true, we will not send the street side to the custodian. */
    bypass_street_side_leg?: boolean;
    /** Flag to bypass trade booking. If true, the trade will not be booked in the system. */
    bypass_trade_booking: boolean;
    /** The client-provided idempotency key. */
    client_external_trade_report_id: string;
    /** DTC ID of the counterparty's clearing firm. */
    counterparty_clearing_firm_id: string;
    /** MPID of the counterparty involved in the street trade. */
    counterparty_id: string;
    /** Trade ID. Often times this will be the ID of the execution made at an external venue. */
    execution_id?: string;
    /** Optional external trade report ID. If provided, this ID will be used instead of auto-generating one.
        Must start with 'etr_' followed by a valid ULID.
        If not provided, the system will generate a unique ID automatically.
         */
    external_trade_report_id?: string;
    /** The trade price. */
    // Hand-edited: made optional for MF manual fill (TR-3189), which omits price
    // entirely. This client is @deprecated/stale (FD-175) — not a clean regen.
    price?: number;
    /** The settlement date for the trade. */
    settle_date: string;
    /** Optional quote snapshot ID. If provided, this snapshot ID will be used instead of creating a new one. */
    snapshot_id?: string;
    /** The timestamp when the trade occurred. */
    trade_time: string;
  };
  fees?: Fee[];
  quotes_snapshot?: {
    isin: string;
    organization_id: string;
    bids: {
      /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytm instead. */
      yield_to_maturity?: number;
      /** Deprecated: not mapped to domain model, will be removed. Use post_fee_ytw instead. */
      yield_to_worst?: number;
      size: number;
      min_size: number;
      venue_mpid: string;
      spread_benchmark_isin?: string | null;
      spread_to_benchmark_bps?: string | null;
      min_balance_remaining?: number | null;
      min_increment?: number | null;
      source: "LOB" | "RFQ";
      pre_fee_price: number;
      post_fee_price: number;
      /** Pre-fee yield to worst (street price, no fees). */
      pre_fee_ytw: number;
      /** Post-fee yield to worst (inclusive of Moment fees). */
      post_fee_ytw: number;
      /** Pre-fee yield to maturity (street price, no fees). */
      pre_fee_ytm: number;
      /** Post-fee yield to maturity (inclusive of Moment fees). */
      post_fee_ytm: number;
      pre_fee_spread_bps?: number | null;
      post_fee_spread_bps?: number | null;
      side: "bid" | "ask";
      disabled: boolean;
      rfq_quote_status?: string;
      rfq_id?: string;
      venue_quote_id?: string;
      settlement_date: number;
    }[];
    asks: Items[];
  };
  /** an option to supply with a new trader ID */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExternalTradeReportResponse = {
  external_trade_report_id: ExternalTradeReportId;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Duration = {
  /** Signed fractions of a second at nanosecond resolution. */
  nanos: number;
  /** Signed seconds of the span of time. */
  seconds: number;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type LobPullConfig = {
  /** If requests are able to be cancelled. */
  cancel_requests_enabled?: boolean;
  /** If the requests are fill or kill. */
  fill_or_kill?: boolean;
  fill_or_kill_timeout_duration?: Duration;
  /** If the venue supports orders with quantity less than par value. */
  fractional_liquidity_enabled?: boolean;
  /** If the quote ID is required. */
  quote_id_required?: boolean;
  /** The number of failed route attempts before the route is blacklisted. */
  route_blacklist_threshold?: number;
  route_blacklist_timeout?: Duration;
  /** If an ack is sent for the order request. */
  sends_ack_on_order_request?: boolean;
  /** If only one aggressor per quote is allowed. */
  single_aggressor_per_quote?: boolean;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DisclosureType = "disclosed" | "anonymous" | "unspecified";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TimeConstraints = {
  /** The allowed durations for the time field. For example, MKTX requires the due time to be (120, 180, 300, 600 seconds). If the array is empty, all durations are allowed. */
  allowed_durations?: Duration[];
  /** Human readable requirements for UI display and operational reference. */
  annotation?: string;
  /** A constant time value (must be today's HH:MM:SS). */
  constant?: string;
  /** Minimum duration from now (must be at least HH:MM:SS away from now). */
  min_duration_from_now?: Duration;
  /** Time quantization. For example, 00:15:00 means times are mapped to 00:00, 00:15, etc. */
  quantization?: Duration;
  /** If the time field is required. */
  required?: boolean;
  /** If the time field is supported. */
  supported?: boolean;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type AssetClassType =
  | "agency"
  | "corporate"
  | "government"
  | "municipal"
  | "treasury"
  | "mbs"
  | "cd"
  | "unspecified";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqType = "bin" | "asap" | "unspecified";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type VenueConfigScope = {
  /** The asset classes that the configuration applies to. */
  asset_classes?: AssetClassType[];
  /** The RFQ types (Bin/ASAP) that the configuration applies to. */
  rfq_types?: RfqType[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqSide = "buy" | "sell" | "unspecified";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RfqInitiatorConfig = {
  /** The time the venue closes (format: 0000-00-00 HH:MM:SS). */
  close_time?: string;
  /** The disclosure types supported by the venue (Anonymous/Disclosed). */
  disclosure_supported?: DisclosureType[];
  due_time_constraints?: TimeConstraints;
  expire_time_constraints?: TimeConstraints;
  firm_until_time_constraints?: TimeConstraints;
  /** The time the venue closes on half days (format: 0000-00-00 HH:MM:SS). */
  half_close_time?: string;
  /** The time the venue opens (format: 0000-00-00 HH:MM:SS). */
  open_time?: string;
  /** If the venue supports outside market hours. */
  outside_market_hours_supported?: boolean;
  /** The price types supported by the venue (percent/spread). */
  price_type_supported?: string[];
  scope?: VenueConfigScope;
  /** The sides supported by the venue (Buy/Sell). */
  side_supported?: RfqSide[];
  /** The type of RFQs supported by the venue (Bin/ASAP). */
  type_supported?: RfqType[];
  /** If the venue trader ID is required. */
  venue_trader_id_required?: boolean;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type VenueConfiguration = {
  lob_pull_configs: LobPullConfig[];
  rfq_initiator_configs: RfqInitiatorConfig[];
  /** The MPID of the venue. */
  venue_mpid: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllVenueConfigurationsResponse = VenueConfiguration[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutingBrokerId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BookingConfigurationId = string;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TradePartyRole =
  | "PRINCIPAL_TRADING_ACCOUNT"
  | "BROKER"
  | "INTERMEDIARY_ACCOUNT"
  | "END_CUSTOMER";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TradeParty = {
  /** The account ID associated with the trade party for trade booking purposes. */
  account_id?: string;
  /** The clearing broker number for the trade party. */
  clearing_broker_number?: string;
  /** The custodian that houses the account */
  custodian_id?: string;
  /** The ID of the trade party. */
  id: string;
  /** The MPID of the trade party if applicable. */
  mpid?: string;
  /** A human readable name for the trade party. */
  name: string;
  /** The ID of the owning organization */
  org_id?: string;
  /** The ID of the fee recipient for the trade party. This is the organization that will receive the fees associated with the trade party. */
  recipient_id?: string;
  /** The risk group ID associated with the trade party for granular filtering. */
  risk_group_id?: string;
  role: TradePartyRole;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TradingCapacity = "riskless_principal" | "principal" | "agency";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BookingConfiguration = {
  /** The timestamp when the booking configuration was archived. */
  archived_at?: string | null;
  /** The timestamp when the booking configuration was created. */
  created_at: string;
  custodian_id?: CustodianId;
  executing_broker_id?: ExecutingBrokerId;
  id: BookingConfigurationId;
  /** A human-readable name for the booking configuration. */
  name: string;
  /** The risk group ID to associate with the booking configuration. */
  risk_group_id: string;
  /** The list of trade parties involved in the trade booking. */
  trade_parties: TradeParty[];
  trading_capacity: TradingCapacity;
  /** The timestamp when the booking configuration was last updated. */
  updated_at: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BookingConfiguration2 = {
  /** the custodian that houses end customer accounts. */
  custodian_id: string;
  /** the owner of this config, which should be the parent org / home office */
  executing_broker_id: string;
  /** A human-readable name for the booking configuration. */
  name: string;
  /** The risk group ID to associate with the booking configuration. */
  risk_group_id: string;
  /** The list of trade parties involved in the trade booking. */
  trade_parties: TradeParty[];
  /** the preferred way to manage trade parties. The order matters for booking. */
  trade_party_ids_in_order: string[];
  trading_capacity: TradingCapacity;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateBookingConfigurationRequest = {
  /** the custodian that houses end customer accounts. */
  custodian_id: string;
  id: BookingConfigurationId;
  /** A human-readable name for the booking configuration. */
  name: string;
  /** The list of trade parties involved in the trade booking. */
  trade_parties: TradeParty[];
  /** the preferred way to manage trade party outside booking configs. The order matters for booking. */
  trade_party_ids_in_order: string[];
  trading_capacity: TradingCapacity;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionInstructionProposal = {
  execution_criteria?: ExecutionCriteria;
  exit_criteria?: ExitCriteria;
  /** The protocol of the execution instruction proposed. */
  protocol: "limit_order_book" | "request_for_quote" | "custodian";
  /** The RFQ protocol parameters for the execution instruction proposed. */
  rfq_protocol_parameters?: RfqProtocolParameters[];
  /** Metadata about the ruleset that auto generated the order. */
  ruleset_metadata?: {
    /** The ID of the proposal. */
    proposal_id: string;
    /** The version ID of the ruleset that auto generated the order. */
    tree_version_id: string;
  } | null;
  /** Whether to skip the limit order book quotes when auto executing. */
  skip_lob_quotes?: boolean;
  /** The strategy of the execution instruction proposed. */
  strategy: "smart_order_routing" | "auto_ex" | "manual";
  /** Whether to suppress the Prevailing Market Price (PMP) check. */
  suppress_pmp_check?: boolean;
  /** The MPID of the venue to sent the order to, if trading on limit order book. */
  venue_mpid?: string | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ExecutionInstructionDecisionTree = {
  /** The date and time the decision tree was created. */
  created_at: string;
  default_proposal?: ExecutionInstructionProposal;
  executing_broker_id: ExecutingBrokerId;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: {
    children?: object[];
    /** The condition of the decision tree node. */
    condition?: string;
    decision?: ExecutionInstructionProposal;
  };
  /** The ID of the user who created the decision tree. */
  user_id?: string;
  /** The version ID of the decision tree. */
  version_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRulesetsResponse = {
  rulesets: ExecutionInstructionDecisionTree[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RulesetScope = "org" | "user";
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateRulesetRequest = {
  /** The default proposal for the decision tree. */
  default_proposal?: ExecutionInstructionProposal;
  /** If true, the ruleset will be validated but not saved to the database. Defaults to false. */
  dry_run?: boolean;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: {
    children?: object[];
    /** The condition of the decision tree node. */
    condition?: string;
    proposal?: ExecutionInstructionProposal;
  };
  scope: RulesetScope;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RulesetSupportedExpressionEnumValue = {
  /** The value of the enum. */
  expression: string;
  /** The description of the enum value. */
  name: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type SupportedExpression = {
  /** A list of values supported RHS of the condition to be evaluated (i.e., {expression} {operator} {enum_values}).
    Will only be non-null if the enum can not easily be deduced on the frontend.
     */
  enum_values?: RulesetSupportedExpressionEnumValue[] | null;
  /** Examples of the expression. */
  examples: string[];
  /** The actual expression to be evaluated. */
  expression: string;
  /** The name of the expression. If the expression is a reference data field, its name will match the reference data API schema. */
  name: string;
  /** Whether the expression is nullable. */
  nullable: boolean;
  /** The operators supported for the expression. */
  operators: string[];
  /** The type of the expression. */
  type: "string" | "enum" | "number" | "boolean";
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Root = {
  /** expr-lang boolean expression. */
  condition: string;
  /** Only set on leaf nodes. */
  decision?:
    | {
        desk_fee: Fee;
        /** Whether the rep fee applies to this order. */
        rep_fee_applies: boolean;
        /** Representative fee configuration. */
        rep_fee?: {
          fee_amount_type: FeeAmountType;
          default_fee_amount: Decimal;
          /** Nullable Decimal number. */
          max_fee_amount?: ((number | null) | (string | null)) | null;
          min_fee_amount?: NullableDecimal;
          /** ULID of the fee recipient. */
          recipient_id: string;
        } | null;
      }[]
    | null;
  children?: Root[] | null;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllFeeScheduleRulesResponse = {
  /** The date and time the decision tree was created. */
  created_at: string;
  /** The date and time the decision tree was archived. */
  archived_at?: string | null;
  /** The date and time when the decision tree becomes effective for calculating fees. */
  creation_effective_at: string;
  /** The date and time when the decision tree becomes archived for calculating fees. */
  archive_effective_at?: string | null;
  /** The risk group ID for the order. */
  risk_group_id: string;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: Root;
  /** The ID of the user who created the decision tree. */
  created_by: string | null;
  /** The ID of the user who archived the decision tree. */
  archived_by?: string | null;
  /** The version ID of the decision tree. */
  version_id: string;
}[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type FeeDecisionTree = {
  /** The date and time the decision tree was created. */
  created_at: string;
  /** The date and time the decision tree was archived. */
  archived_at?: string | null;
  /** The date and time when the decision tree becomes effective for calculating fees. */
  creation_effective_at: string;
  /** The date and time when the decision tree becomes archived for calculating fees. */
  archive_effective_at?: string | null;
  /** The risk group ID for the order. */
  risk_group_id: string;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: Root;
  /** The ID of the user who created the decision tree. */
  created_by: string | null;
  /** The ID of the user who archived the decision tree. */
  archived_by?: string | null;
  /** The version ID of the decision tree. */
  version_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertFeeScheduleRulesRequest = {
  /** The time when the fee schedule rule decision tree becomes effective. */
  creation_effective_at: string;
  /** If true, the rules will be validated but not saved to the database. Defaults to false. */
  dry_run?: boolean;
  /** The ID of the fee schedule rule decision tree. If not given, it will be auto-generated. */
  id?: string;
  /** The name of the fee schedule rule decision tree. */
  name: string;
  /** The ID of the risk group this fee schedule rule applies to. */
  risk_group_id: string;
  /** Recursive decision-tree node. Condition is an expr-lang expression evaluated against DecisionTreeRecord. */
  root: {
    /** expr-lang boolean expression. */
    condition: string;
    /** Only set on leaf nodes. */
    decision?:
      | {
          desk_fee: Fee;
          /** Whether the rep fee applies to this order. */
          rep_fee_applies: boolean;
          /** Representative fee configuration. */
          rep_fee?: {
            fee_amount_type: FeeAmountType;
            default_fee_amount: Decimal;
            /** Nullable Decimal number. */
            max_fee_amount?: ((number | null) | (string | null)) | null;
            min_fee_amount?: NullableDecimal;
            /** ULID of the fee recipient. */
            recipient_id: string;
          } | null;
        }[]
      | null;
    children?: Root[] | null;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteFeeScheduleRulesRequest = {
  /** The timestamp to set as the `archive_effective_at` for the fee schedule rules. If not provided, the T+1 timestamp will be used by default. */
  archive_effective_at?: string;
  /** The ID of the risk group this fee schedule rule applies to. */
  risk_group_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type Root2 = object;
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListAllRepFeeScheduleRulesResponse = {
  /** The date and time the decision tree was created. */
  created_at: string;
  /** The date and time the decision tree was archived. */
  archived_at?: string | null;
  /** The date and time when the decision tree becomes effective for calculating fees. */
  creation_effective_at: string;
  /** The date and time when the decision tree becomes archived for calculating fees. */
  archive_effective_at?: string | null;
  /** The risk group ID for the order. */
  risk_group_id: string;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: Root2;
  /** The ID of the user who created the decision tree. */
  created_by: string | null;
  /** The ID of the user who archived the decision tree. */
  archived_by?: string | null;
  /** The version ID of the decision tree. */
  version_id: string;
}[];
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type RepFeeDecisionTree = {
  /** The date and time the decision tree was created. */
  created_at: string;
  /** The date and time the decision tree was archived. */
  archived_at?: string | null;
  /** The date and time when the decision tree becomes effective for calculating fees. */
  creation_effective_at: string;
  /** The date and time when the decision tree becomes archived for calculating fees. */
  archive_effective_at?: string | null;
  /** The risk group ID for the order. */
  risk_group_id: string;
  /** The ID of the decision tree. */
  id: string;
  /** The name of the decision tree. */
  name: string;
  root: Root2;
  /** The ID of the user who created the decision tree. */
  created_by: string | null;
  /** The ID of the user who archived the decision tree. */
  archived_by?: string | null;
  /** The version ID of the decision tree. */
  version_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpsertRepFeeScheduleRulesRequest = {
  /** The time when the rep fee schedule rule decision tree becomes effective. */
  creation_effective_at: string;
  /** If true, the rules will be validated but not saved to the database. Defaults to false. */
  dry_run?: boolean;
  /** The ID of the rep fee schedule rule decision tree. If not given, it will be auto-generated. */
  id?: string;
  /** The name of the rep fee schedule rule decision tree. */
  name: string;
  /** The ID of the risk group this rep fee schedule rule applies to. */
  risk_group_id: string;
  root: object;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type DeleteRepFeeScheduleRulesRequest = {
  /** The timestamp to set as the `archive_effective_at` for the rep fee schedule rules. If not provided, the T+1 timestamp will be used by default. */
  archive_effective_at?: string;
  /** The ID of the risk group this rep fee schedule rule applies to. */
  risk_group_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type GetFeesForInstrumentResponse = {
  fees: Fee[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrgDefaultTraderUserIdResponse = {
  /** The ULID of the user whose trader profile has been set as the default trader for the organization. */
  user_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type PostDefaultTraderProfileForOrgRequest = {
  /** The ULID of the user whose trader profile is to be set. */
  user_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type TraderProfile = {
  /** the Moment ID for this user */
  user_id: string;
  /** the registered Bloomberg ID for this user */
  bloomberg_id?: string;
} & {
  /** The organization ID this trader profile belongs to. */
  org_id: string;
  /** List of venue-specific trader info */
  venue_trader_info: VenueTraderInfo[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateTraderProfileRequest = {
  /** The Bloomberg ID of the trader. */
  bloomberg_id?: string;
  /** List of venue-specific trader info. */
  venue_trader_info: VenueTraderInfo[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type UpdateTraderProfileRequest = {
  /** The Bloomberg ID of the trader. */
  bloomberg_id?: string;
  /** List of venue-specific trader info. */
  venue_trader_info: VenueTraderInfo[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderCostsResponse = {
  /** Accrued interest in dollars, calculated from the bond's last coupon payment date through the settlement date. Computed using the calculator service based on the instrument's coupon schedule and day count convention. */
  accrued_interest: number;
  /** Total fees in dollars. Calculated as the effective markup from the risk group's fee configuration, converted from price space (percentage of par) to dollars: markup * quantity * principal_factor / 100. Fees use a yield calculator for yield-based fee tiers. If no risk_group_id is provided in the request, this will be zero. */
  fees: number;
  /** Market value of the order in dollars, calculated as: price * quantity * principal_factor / 100. This represents the base value of the securities being traded. */
  market_value: number;
  /** Total net money in dollars that will be exchanged for this order. This is the final amount the customer will pay (for buys) or receive (for sells). Calculated using the volume library which combines market value, accrued interest, and fees based on the order side. */
  net_money: number;
  /** The customer-facing price (inclusive of fees) used for this calculation, expressed as a percentage of par. This will be either the price provided in the request or the estimated price retrieved from the internal price store if no price was provided. */
  price: number;
  /** The settlement date used for this calculation in YYYYMMDD format. This will be either the settlement_date provided in the request, or a calculated default: pre-issuance bonds use the issue date, outstanding bonds use standard T+1 or T+2 conventions. */
  settlement_date: number;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type OrderCostsRequest = {
  amount: Amount;
  instrument_id: InstrumentId;
  /** Optional customer-facing price for the instrument (inclusive of fees). If provided, this exact price will be used for calculations. If not provided, the endpoint will attempt to retrieve an estimated price from the internal price store. If the price store lookup fails, the request will return a 400 error. */
  price?: number | null;
  /** Optional risk group ID for fetching fee configuration. If provided, fees will be calculated based on the risk group's effective markup configuration. If not provided, fees will be zero. */
  risk_group_id?: string | null;
  /** Optional settlement date for the order in YYYYMMDD format (e.g., 20090101). If not provided, a default settlement date will be calculated based on the instrument status: pre-issuance bonds use the issue date, while outstanding bonds use standard T+1 or T+2 settlement conventions. */
  settlement_date?: number | null;
  side: OrderSide;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type BatchAutoExConfig = {
  /** Client-generated idempotency key for the auto-ex execution order. */
  client_execution_order_id: string;
  execution_criteria: {
    /** Minimum wait time for the execution order. */
    min_wait_time: string;
    /** Minimum number of quotes required on the side of the order, before execution can proceed. If the protocol is `request_for_quote`, this is the minimum number of RFQ quotes required. If the protocol is `limit_order_book`, this is the minimum number of LOB quotes required. */
    min_number_quotes: number;
    /** Maximum transaction cost in dollars. Max buy price = estimated price * par value + maxDollar, Min sell price = estimated price * par value - maxDollar. Ex. a value of `5` would mean the transaction cost must be within $5 of the instrument's estimated price in dollars, meaning when buying a bond with a estimated price of $100 and a par value of $1000, the transaction cost must be below $1005. */
    max_transaction_cost_dollar?: string;
    /** Maximum transaction cost in percent. Max buy price = estimated price * (1 + maxPct / 100), Min sell price = estimated price * (1 - maxPct / 100). Ex. a value of `5` would mean the transaction cost must be within 5% of the instrument's estimated price in percent, meaning when buying a bond with a estimated price of $100, the transaction cost must be below $105. */
    max_transaction_cost_percent?: string;
    /** Maximum transaction cost in yield. Max buy yield = estimated ytw - maxYTW, Max sell yield = estimated ytw + maxYTW. Ex. a value of `0.5` would mean the transaction cost must be within 50 bps of the instrument's estimated yield, meaning when buying a bond with an estimated yield to worst of 1.5%, the transaction cost must be above 1.0%. */
    max_transaction_cost_yield?: string;
  };
  exit_criteria: {
    /** Timeout for the execution order. */
    timeout: string;
  };
  /** Trader ID for the execution orders. Duplicative but maintained for parity with existing execution order creation. */
  trader_id?: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListRfqItem = {
  amount: Amount;
  /** Client-generated idempotency key for the RFQ. */
  client_rfq_id: string;
  introducing_broker_id: IntroducingBrokerId;
  /** The ISIN identifier for the security to trade. */
  isin: string;
  /** The Moment order ID this RFQ item and execution order correspond to. */
  moment_order_id: string;
  /** The risk group ID for the order. */
  risk_group_id: string;
  /** The targeted settlement date for the order in the format of YYYYMMDD, like 20090101. */
  settlement_date?: number | null;
  side: OrderSide;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type ListRfq = {
  /** The asset class for this List RFQ grouping. */
  asset_class: string;
  auto_ex_config?: BatchAutoExConfig;
  executing_broker_id: ExecutingBrokerId;
  /** Individual RFQ items within this list, one per order. */
  rfq_items: ListRfqItem[];
  rfq_protocol_parameters: {
    /** The MPID of the venue. */
    venue_mpid: string;
    /** The type of the RFQ. */
    type: "bin" | "asap";
    /** The disclosure for the RFQ. Currently, only `disclosed` is supported. */
    disclosure: "disclosed" | "anonymous";
    /** Specifies how duration following RFQ creation, after which the RFQ becomes due. */
    due_after?: string;
    /** Specifies the duration following the due time (or submission time if no due time is defined) during which quotes are considered subject. */
    subject_after?: string;
    /** Specifies the duration following the latest of due time, subject time, or submission time, after which the RFQ expires. */
    expire_after?: string;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateBatchListRfqRequest = {
  /** List RFQ definitions, one per asset class grouping. */
  list_rfqs: ListRfq[];
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateRfqResponse = {
  /** Unique, Moment-generated identifier for the RFQ. */
  rfq_id: string;
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export type CreateRfq = {
  amount: Amount;
  /** The ID of the RFQ as provided by the client. */
  client_rfq_id?: string;
  disclosure: DisclosureType;
  /** The time at which quotes for this RFQ are due. */
  due_time?: string;
  /** The time at which the RFQ will expire. */
  expire_time?: string;
  /** The time until which the quotes for this RFQ are firm. */
  firm_until_time?: string;
  ib_id: IntroducingBrokerId;
  /** The ISIN of the instrument being traded. */
  instrument_id: string;
  /** When creating an RFQ to trade against an existing order, the identifier of the corresponding order. */
  moment_order_id?: string;
  risk_group_id: RiskGroupId;
  /** The date on which the trade for this RFQ is to be settled. */
  settlement_date?: string | null;
  side: OrderSide;
  /** Whether to skip fees for this RFQ. If true, the quotes will not include fees. */
  skip_fees?: boolean;
  type: RfqType;
  /** The Market Participant Identifier (MPID) of the venue. */
  venue_mpid: string;
  venue_trader_info?: {
    /** The MPID of the venue. */
    venue_mpid: string;
    /** The ID of the custodian for the venue trader info. */
    custodian_id: string;
    /** The ID of the venue trader. */
    venue_trader_id: string;
    /** The ID of the custodian account for the venue trader. */
    custodian_account_at_venue: string;
  };
};
/** @deprecated Use `@moment/horizon-data-access` instead — stale readme spec, see FD-175. */
export const {
  usePostOrderMutation,
  useGetAllOrdersQuery,
  useLazyGetAllOrdersQuery,
  useGetOrderByOrderIdQuery,
  useLazyGetOrderByOrderIdQuery,
  useDeleteOrderByOrderIdMutation,
  useAllocateOrderByOrderIdMutation,
  useGetEventsQuery,
  useLazyGetEventsQuery,
  useBulkOrderSubmissionMutation,
  useBulkCancelOrdersMutation,
  useBulkAdvisorOrderSubmissionMutation,
  useApproveOrderByOrderIdMutation,
  useRejectOrderByOrderIdMutation,
  useUpdateParentOrderMetadataMutation,
  useCreateExecutionOrderLobSorMutation,
  useCreateExecutionOrderLobManualMutation,
  useCreateExecutionOrderCustodianManualMutation,
  useCreateExecutionOrderManualRfqMutation,
  useCreateExecutionOrderAutoExRfqMutation,
  useCreateExecutionOrderExternalTradeMutation,
  useCancelExecutionOrderMutation,
  useReportExternalTradeMutation,
  useDeleteAllocationMutation,
  useListAllVenueConfigurationsQuery,
  useLazyListAllVenueConfigurationsQuery,
  useListBookingConfigurationsQuery,
  useLazyListBookingConfigurationsQuery,
  useCreateBookingConfigurationMutation,
  useUpdateBookingConfigurationMutation,
  useDeleteBookingConfigurationByIdMutation,
  useProposeExecutionInstructionMutation,
  useListAllRulesetsQuery,
  useLazyListAllRulesetsQuery,
  useUpsertRulesetMutation,
  useDeleteRulesetMutation,
  useListSupportedExpressionsQuery,
  useLazyListSupportedExpressionsQuery,
  useListAllFeeScheduleRulesQuery,
  useLazyListAllFeeScheduleRulesQuery,
  useUpsertFeeScheduleRulesMutation,
  useDeleteFeeScheduleRulesMutation,
  useListAllRepFeeScheduleRulesQuery,
  useLazyListAllRepFeeScheduleRulesQuery,
  useUpsertRepFeeScheduleRulesMutation,
  useDeleteRepFeeScheduleRulesMutation,
  useGetFeesForInstrumentQuery,
  useLazyGetFeesForInstrumentQuery,
  usePostDefaultTraderForOrgMutation,
  useGetDefaultTraderForOrgQuery,
  useLazyGetDefaultTraderForOrgQuery,
  useDeleteDefaultTraderForOrgMutation,
  useGetTraderProfileQuery,
  useLazyGetTraderProfileQuery,
  useCreateTraderProfileMutation,
  useUpdateTraderProfileMutation,
  useDeleteTraderProfileMutation,
  usePostOrderCostsMutation,
  useCreateBatchListRfqWithAutoExMutation,
  useDeleteRfqMutation,
  useCreateRfqMutation,
} = injectedRtkApi;
